import { render, staticRenderFns } from "./CommonPanel.vue?vue&type=template&id=7632c720&scoped=true"
import script from "./CommonPanel.vue?vue&type=script&lang=ts"
export * from "./CommonPanel.vue?vue&type=script&lang=ts"
import style0 from "./CommonPanel.vue?vue&type=style&index=0&id=7632c720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632c720",
  null
  
)

export default component.exports